import React, { useState, useEffect } from 'react';
import cs from 'classnames';
import { useConfigContext } from '../config-provider';
import IconImgLoading from '../../icon/react-icon/IconImgLoading';
export var ImageSize;
(function (ImageSize) {
    ImageSize["Origin"] = "origin";
    ImageSize["Large"] = "large";
    ImageSize["Medium"] = "medium";
    ImageSize["Thumb"] = "thumb";
})(ImageSize || (ImageSize = {}));
export var ImageStatus;
(function (ImageStatus) {
    ImageStatus["None"] = "none";
    ImageStatus["Loading"] = "loading";
    ImageStatus["Success"] = "success";
    ImageStatus["ThumbSuccess"] = "thumb-success";
    ImageStatus["Error"] = "error";
})(ImageStatus || (ImageStatus = {}));
export function ImageElement(props) {
    var _a = props.className, className = _a === void 0 ? '' : _a, src = props.src, _b = props.alt, alt = _b === void 0 ? '' : _b, _c = props.loadThumb, loadThumb = _c === void 0 ? true : _c, 
    // showLoadingIcon = true,
    _d = props.width, 
    // showLoadingIcon = true,
    width = _d === void 0 ? 46 : _d, _e = props.height, height = _e === void 0 ? 46 : _e, _f = props.backgroundColor, backgroundColor = _f === void 0 ? 'white' : _f, _g = props.onClick, onClick = _g === void 0 ? function () { } : _g, _h = props.onError, onError = _h === void 0 ? function () { } : _h, _j = props.onSuccess, onSuccess = _j === void 0 ? function () { } : _j;
    var _k = useState(''), imageSrc = _k[0], setImageSrc = _k[1];
    var _l = useState(ImageStatus.None), status = _l[0], setStatus = _l[1];
    var common = useConfigContext().prefixCls;
    var prefixCls = common + "-image";
    var _m = useState(true), showLoadingIconFlag = _m[0], setLoadingIconFlag = _m[1];
    useEffect(function () {
        setStatus(ImageStatus.Loading);
        if (loadThumb) {
            loadThumbImage();
        }
        loadOriginImage();
    }, []);
    function getThumbImage() {
        if (props.thumbImage) {
            return props.thumbImage;
        }
        return src;
    }
    function loadOriginImage() {
        var img = new Image(width, height);
        img.onload = function () {
            setImageSrc(src);
            setStatus(ImageStatus.Success);
            setLoadingIconFlag(false);
            onSuccess();
        };
        img.onerror = function () {
            setStatus(ImageStatus.Error);
            setLoadingIconFlag(true);
            onError();
        };
        img.src = src;
    }
    function loadThumbImage() {
        var thumbImage = getThumbImage();
        if (thumbImage === src) {
            return;
        }
        var img = new Image(width, height);
        img.onload = function () {
            if (!imageSrc) {
                setImageSrc(thumbImage);
                setStatus(ImageStatus.ThumbSuccess);
                setLoadingIconFlag(false);
            }
        };
        img.src = thumbImage;
    }
    return (React.createElement("div", { className: cs(prefixCls + "-image-wrapper", prefixCls + "-image-status-" + status, className), style: {
            height: height,
            width: width,
            backgroundColor: backgroundColor
        }, onClick: onClick },
        showLoadingIconFlag && React.createElement(IconImgLoading, { style: { width: '47.375%', height: '54.667%' }, className: prefixCls + "-loading-icon" }),
        React.createElement("img", { width: width, height: height, alt: alt, className: prefixCls + "-image", src: src })));
}
var ForwardRefImage = React.forwardRef(ImageElement);
export default ForwardRefImage;
//# sourceMappingURL=index.js.map